import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'

Vue.use(Router)
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },{
      path: '/introduce',
      name: 'introduce',
      component: () => import("@/components/introduce/introduce.vue"),
      children:[
        {
          path: 'scan',
          name: 'scan',
          component: () => import("@/components/introduce/scan.vue"),
        },{
          path: 'quick',
          name: 'quick',
          component: () => import("@/components/introduce/quick.vue"),
        }
        ,{
          path: 'ofdChange',
          name: 'ofdChange',
          component: () => import("@/components/introduce/ofdChange.vue"),
        },{
          path: 'batch',
          name: 'batch',
          component: () => import("@/components/introduce/batch.vue"),
        }
      ]
    },{
      path: '/download',
      name: 'download',
      component: () => import("@/components/download.vue"),
    },{
      path: '/contact',
      name: 'contact',
      component: () => import("@/components/contact.vue"),
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js